import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';

@Component({
  selector: 'app-add-book-credit-price',
  templateUrl: './add-book-credit-price.component.html',
  styleUrls: ['./add-book-credit-price.component.scss']
})
export class AddBookCreditPriceComponent implements OnInit {
  bookreceipt: any;
  bookdata: any[] = [];
  updatedBooks: any[] = [];

  total_credit_amt: number = 0;
  initial_total_val: number = 0;
  totalAmount1Sum: number = 0;
  shippingChargesSum: number = 0;
  crdtvAmt = 0;
  selectedAmt = 0;
  selectedCopies = 0;
  crdtnote_amt = 0;
  balanceAmt = 0;
  totalReturnCopies: number = 0;
  totalCreditAmount: number = 0;
  bal = 0;
  bname: any;
  previousRem: any;
  newReturnCopies: any;
  total_remaining_amt = 0;
  total_val = 0;
  value = 0;
  newvalue = 0;

  newRemark: any = "";
  selectedBooks: any;
  receive_amt: number;
  totalRemainingAmount: number;

  constructor(
    public service: DigisubservicesService,
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<AddBookCreditPriceComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    debugger
    this.bookreceipt = this.data['book'];

    this.crdtvAmt = isNaN(this.data['crdtAmt']) ? 0 : this.data['crdtAmt'];
    this.selectedAmt = isNaN(this.data['seAmt']) ? 0 : this.data['seAmt'];
    this.balanceAmt = isNaN(this.data['balAmt']) ? 0 : this.data['balAmt'];
    this.bal = isNaN(this.data['bal']) ? 0 : this.data['bal'];
    this.bname = this.data?.['bookName'] ?? '';
    this.selectedCopies = isNaN(this.data['seCopies']) ? 0 : this.data['seCopies'];
    if (this.bookdata && this.bookdata.length > 0) {
      this.bookdata = this.bookdata.map(book => ({
        ...book,
        return_copies: 0,
        credit_amount: 0,
        credit_note_amount: 0
      }));
    }

    const fetchBooks = this.service.getCrdtWiseBooks(this.bookreceipt['order_no']);
    fetchBooks.subscribe((data) => {
      data.forEach((book) => {
        const total_amount = parseInt(book['total']) + parseInt(book['shipping_charges']);
        const rcvd_amt = parseInt(book['crdtnote_amt']) || 0;

        const received = Number(book['received_amt']) || 0;
        const remaining_amt: number = total_amount - received;


        this.total_val += rcvd_amt;
        this.total_remaining_amt += remaining_amt;
        this.receive_amt = parseInt(book['received_amt']);
        this.previousRem = this.total_remaining_amt;
        

        this.bookdata.push({
          id: this.bookreceipt['id'],
          bookid: book['bd_id'],
          book_name: book['book_name'],
          book_price: book['book_price'],
          book_copies: book['book_copies'],
          total: book['total'],
          shipping_charges: book['shipping_charges'],
          rep_name: book['rep_name'],
          office_rep_name: book['office_rep_name'],
          return_copies: book['return_copies'] || 0,
          crdtnote_amt: book['crdtnote_amt'] || 0,
          credit_remark: book['credit_remark'] || '',
          total_amount: total_amount,
          received_amt: book['received_amt'],
          remaining_amt: book['remaining_amt'],
          credit_amount: 0,
          manualOverride: false,
          invoice_no: this.bookreceipt['invoice_no'],
          isDisabled: remaining_amt === 0 || remaining_amt === 0.00,
          order_no: book['order_no']
        });
      });
       this.totalRemainingAmount = this.round2(
    this.bookdata.reduce((sum, b) => sum + (this.toNum(b.remaining_amt) || 0), 0)
  );
    });
  }

  private toInt(v: any): number {
    const n = parseInt(v, 10);
    return Number.isFinite(n) ? n : 0;
  }

  private toNum(v: any): number {
    const n = parseFloat(v);
    return Number.isFinite(n) ? n : 0;
  }

  private round2(n: number): number {
    return Math.round((n + Number.EPSILON) * 100) / 100;
  }

  customFloorLike(amount: number): number {
    return Math.round((amount + Number.EPSILON) * 100) / 100;
  }

  // calculateCopies(event: any, book: any) {
  //   const val = parseInt(event?.target?.value, 10);
  //   const returnCopies = isNaN(val) ? 0 : val;
  //   const salePrice = this.toNum(book?.book_price);
    

  //   let creditAmount: number;
  //   if (
  //     book &&
  //     book.manualOverride &&
  //     book.credit_amount !== undefined &&
  //     book.credit_amount !== null &&
  //     String(book.credit_amount) !== ''
  //   ) {
  //     creditAmount = this.toNum(book.credit_amount);
  //   } else {
  //     creditAmount = this.customFloorLike(salePrice * returnCopies);
  //   }

  //   const bIdx = this.bookdata.findIndex(b => b.bookid === book.bookid);
  //   const updatedBook = {
  //     ...(bIdx !== -1 ? this.bookdata[bIdx] : book),
  //     return_copies: returnCopies,
  //     credit_amount: creditAmount,
  //     credit_note_amount: creditAmount
  //   };

  //   if (bIdx !== -1) {
  //     this.bookdata[bIdx] = updatedBook;
  //   } else {
  //     this.bookdata.push(updatedBook);
  //   }

  //   const uIdx = this.updatedBooks.findIndex(b => b.bookid === book.bookid);
  //   if (uIdx !== -1) this.updatedBooks[uIdx] = updatedBook;
  //   else this.updatedBooks.push(updatedBook);

  //   this.recalculateTotals();
  // }

  calculateCopies(event: any, book: any) {
  const val = parseInt(event?.target?.value, 10);
  let returnCopies = isNaN(val) ? 0 : val;

  // ✅ Check: return copies cannot be greater than available copies
  const availableCopies = this.toInt(book?.book_copies);
  if (returnCopies > availableCopies) {
    returnCopies = availableCopies;
    // Optionally show warning to user
    alert(`Return copies cannot exceed available copies `);
  }

  const salePrice = this.toNum(book?.book_price);

  let creditAmount: number;
  if (
    book &&
    book.manualOverride &&
    book.credit_amount !== undefined &&
    book.credit_amount !== null &&
    String(book.credit_amount) !== ''
  ) {
    creditAmount = this.toNum(book.credit_amount);
  } else {
    creditAmount = this.customFloorLike(salePrice * returnCopies);
  }

  const bIdx = this.bookdata.findIndex(b => b.bookid === book.bookid);
  const updatedBook = {
    ...(bIdx !== -1 ? this.bookdata[bIdx] : book),
    return_copies: returnCopies,
    credit_amount: creditAmount,
    credit_note_amount: creditAmount
  };

  if (bIdx !== -1) {
    this.bookdata[bIdx] = updatedBook;
  } else {
    this.bookdata.push(updatedBook);
  }

  const uIdx = this.updatedBooks.findIndex(b => b.bookid === book.bookid);
  if (uIdx !== -1) this.updatedBooks[uIdx] = updatedBook;
  else this.updatedBooks.push(updatedBook);

  this.recalculateTotals();
}


  onCreditAmountInput(event: any, book: any) {
    const val = parseInt(event?.target?.value);
    const creditAmount = isNaN(val) ? 0 : val;

    const bIdx = this.bookdata.findIndex(b => b.bookid === book.bookid);
    if (bIdx !== -1) {
      this.bookdata[bIdx].credit_amount = creditAmount;
      this.bookdata[bIdx].credit_note_amount = creditAmount;
      this.bookdata[bIdx].manualOverride = true;
    } else {
      this.bookdata.push({
        ...book,
        credit_amount: creditAmount,
        credit_note_amount: creditAmount,
        manualOverride: true
      });
    }

    const updatedBook = {
      ...(bIdx !== -1 ? this.bookdata[bIdx] : book),
      credit_amount: creditAmount,
      credit_note_amount: creditAmount,
      manualOverride: true
    };
    const uIdx = this.updatedBooks.findIndex(b => b.bookid === book.bookid);
    if (uIdx !== -1) this.updatedBooks[uIdx] = updatedBook;
    else this.updatedBooks.push(updatedBook);

    this.recalculateTotals();
  }


  // recalculateTotals() {
  //   this.newReturnCopies = this.bookdata.reduce((sum, b) => sum + (this.toInt(b.return_copies) || 0), 0);
  //   this.totalReturnCopies = this.newReturnCopies;

  //   this.totalCreditAmount = this.round2(
  //     this.bookdata.reduce((sum, b) => sum + (this.toNum(b.credit_amount) || 0), 0)
  //   );

  //   this.selectedAmt = this.totalCreditAmount;
  //   this.balanceAmt = (Number(this.crdtvAmt) || 0) - this.selectedAmt;
  // }

  recalculateTotals() {
    // total return copies
    this.newReturnCopies = this.bookdata.reduce(
      (sum, b) => sum + (this.toInt(b.return_copies) || 0),
      0
    );
    this.totalReturnCopies = this.newReturnCopies;

    // total credit amount
    this.totalCreditAmount = this.round2(
      this.bookdata.reduce((sum, b) => sum + (this.toNum(b.credit_amount) || 0), 0)
    );
    this.totalAmount1Sum = this.round2(
      this.bookdata.reduce(
        (sum, b) => sum + ((this.toNum(b.credit_amount) || 0) + (this.toNum(b.shipping_charges) || 0)),
        0
      )
    );
    this.selectedAmt = this.totalAmount1Sum;
    this.balanceAmt = (Number(this.crdtvAmt) || 0) - this.selectedAmt;

    // total shipping charges (use toNum to handle strings)
    this.shippingChargesSum = this.round2(
      this.bookdata.reduce((sum, b) => sum + (this.toNum(b.shipping_charges) || 0), 0)
    );
    

    // total of (credit + shipping) across all rows
    this.totalAmount1Sum = this.round2(
      this.bookdata.reduce(
        (sum, b) => sum + ((this.toNum(b.credit_amount) || 0) + (this.toNum(b.shipping_charges) || 0)),
        0
      )

    );
  }

onRemarkChange(value: string, book: any) {

  // update remark only for this book
  book.remark = value;
  this.newRemark=value;

  // also track this in updatedBooks so it gets passed back
const uIdx = this.updatedBooks.findIndex(b => b.bookid === book.bookid);

if (uIdx !== -1) {
  this.updatedBooks[uIdx].remark = value;
}
else{
  this.updatedBooks.push({ ...book, remark: value });
}

}
onRemarkTypeChange(value: string, book: any) {

  book.remarkType = value;

  if (value === 'manual') {
    // don't touch remark yet
    book.manualRemark = '';
    book.remark = '';
  } else {
    book.remark = value;
    book.manualRemark = '';
  }

  this.syncUpdatedBook(book);
}
onManualRemarkChange(value: string, book: any) {

  book.manualRemark = value;

  // ✅ FINAL VALUE goes here
  book.remark = value;

  this.syncUpdatedBook(book);
}

  //  onManualRemarkChange(value: string, book: any) {

  //   book.manualRemark = value;

  //   this.syncUpdatedBook(book);
  //  }

  /* ---------------------------------------
      Sync Updated Books
  ----------------------------------------*/

 private syncUpdatedBook(book: any) {

  const index = this.updatedBooks.findIndex(
    b => b.bookid === book.bookid
  );

  const updated = {
    ...book,
    remark: book.remark || ''
  };

  if (index !== -1) {
    this.updatedBooks[index] = updated;
  } else {
    this.updatedBooks.push(updated);
  }

}
  onShippingChargesInput(event: any, book: any): void {
    // accept either $event from (ngModelChange) or event.target.value from (input) style
    const raw = (typeof event === 'object' && event?.target) ? event.target.value : event;
    const val = parseFloat(raw);
    const shipping = isNaN(val) ? 0 : val;

    // find book in bookdata (same pattern as onCreditAmountInput)
    const bIdx = this.bookdata.findIndex(b => b.bookid === book.bookid);
    if (bIdx !== -1) {
      this.bookdata[bIdx].shipping_charges = shipping;
      // ensure credit_amount is numeric when calculating row total
      const credit = this.toNum(this.bookdata[bIdx].credit_amount) || 0;
      this.bookdata[bIdx].total_amount1 = this.round2(credit + shipping);
    } else {
      const credit = this.toNum(book.credit_amount) || 0;
      this.bookdata.push({
        ...book,
        shipping_charges: shipping,
        total_amount1: this.round2(credit + shipping)
      });
    }

    // update/track in updatedBooks similar to onCreditAmountInput
    const updatedBook = {
      ...(bIdx !== -1 ? this.bookdata[bIdx] : { ...book, shipping_charges: shipping }),
      shipping_charges: shipping,
      total_amount1: this.round2((this.toNum((bIdx !== -1 ? this.bookdata[bIdx].credit_amount : book.credit_amount)) || 0) + shipping),
      manualOverride: true
    };

    const uIdx = this.updatedBooks.findIndex(b => b.bookid === book.bookid);
    if (uIdx !== -1) this.updatedBooks[uIdx] = updatedBook;
    else this.updatedBooks.push(updatedBook);

    // recalc overall totals immediately
    this.recalculateTotals();
  }
  // Utility: Calculate total_amount1 for a book
  calculateTotalAmount1(book: any): number {
    const credit = Number(book.credit_amount) || 0;
    const shipping = Number(book.shipping_charges) || 0;
    return this.round2(credit + shipping);
  }






  // calculateTotals(): void {
  //   this.totalAmount1Sum = this.selectedBooks
  //     .reduce((sum, b) => sum + (Number(b.total_amount1) || 0), 0);

  //   this.shippingChargesSum = this.selectedBooks
  //     .reduce((sum, b) => sum + (Number(b.shipping_charges) || 0), 0);
  // }


  // save() {
  //   this.recalculateTotals();

  //   this.dialogRef.close({
  //     data: this.updatedBooks,
  //     selecetdAmt: this.totalCreditAmount,
  //     returnCopies: this.totalReturnCopies,
  //     totoal_rem: this.previousRem,
  //     remaining_amt: this.total_remaining_amt,
  //     value: this.totalCreditAmount,
  //     retCopies: this.totalReturnCopies,
  //     newRemark: this.newRemark, // ✅ will now have last selected remark
  //     id: this.bookreceipt['id'],
  //     bookwiseCredits: this.bookdata.map(b => ({
  //       bookid: b.bookid,
  //       credit_amount: b.credit_amount || 0,
  //       remark: b.remark || '' // ✅ send remark with each book
  //     }))
  //   });
  // }

//  save() {
//   this.recalculateTotals();

//   // ✅ Create a proper summary of all book remarks
//   this.newRemark = this.bookdata
//   .filter(b => b.remark && b.remark.trim() !== '') // Only include books with a remark
//   .map(b => b.remark.trim())                       // Take only the remark
//   .join('; ');                                       // Join with semicolon and space

//   this.dialogRef.close({
//     data: this.updatedBooks,
//     selecetdAmt: this.totalAmount1Sum,
//     returnCopies: this.totalReturnCopies,
//     totoal_rem: this.previousRem,
//     remaining_amt: this.total_remaining_amt,
//     value: this.totalAmount1Sum,
//     retCopies: this.totalReturnCopies,
//     newRemark: this.newRemark, // ✅ Properly formatted summary of remarks
//     remainingamt: this.total_remaining_amt - this.receive_amt,
//     id: this.bookreceipt['id'],

//     totalShippingCharges: this.shippingChargesSum,
//     totalAmount1Sum: this.totalAmount1Sum,

//     bookwiseCredits: this.bookdata.map(b => {
//       const credit = Number(b.credit_amount) || 0;
//       const shipping = b.shipping_charges !== undefined && b.shipping_charges !== null
//         ? Number(b.shipping_charges)
//         : 0;

//       return {
//         bookid: b.bookid,
//         credit_amount: credit,
//         shipping_charges: shipping,
//         total_amount1: credit + shipping,
//         remark: b.remark || ''
//       };
//     })
//   });
// }

save() {
  debugger

  this.recalculateTotals();

  const uniqueRemarks = Array.from(
    new Set(
      this.bookdata
        .filter(b => b.remark && b.remark.trim() !== '')
        .map(b => b.remark.trim())
    )
  );

  this.newRemark = uniqueRemarks.join('; ');

  this.dialogRef.close({

    data: this.updatedBooks,

    selecetdAmt: this.totalAmount1Sum,

    returnCopies: this.totalReturnCopies,

    totoal_rem: this.previousRem,

    remaining_amt: this.total_remaining_amt,

    value: this.totalAmount1Sum,

    retCopies: this.totalReturnCopies,

    newRemark: this.newRemark,

    remainingamt: this.total_remaining_amt - this.receive_amt,

    id: this.bookreceipt['id'],

    totalShippingCharges: this.shippingChargesSum,

    totalAmount1Sum: this.totalAmount1Sum,

    bookwiseCredits: this.bookdata.map(b => {

      const credit = Number(b.credit_amount) || 0;
      const shipping = Number(b.shipping_charges) || 0;

      return {
        bookid: b.bookid,
        credit_amount: credit,
        shipping_charges: shipping,
        total_amount1: credit + shipping,
        remark: b.remark || ''
      };

    })

  });

}





}
